import Footer from "../Footer";
import Header from "../Header";

const PrivacyPolicy = () => {
  return (
    <div className="body">
      <Header />

      <div className="wrapper">
        <main className="page">
          <section className="legal-content">
            <div className="container-fix-width">
              <div className="legal-content-wrap">
                <h1 className="main-title">Privacy Policy</h1>
                <p>
                  <strong>Last updated</strong>: [May 01, 2025]
                </p>
                <p>
                  At <strong>SportBeagle</strong>, your privacy is a top
                  priority. This Privacy Policy explains what personal data we
                  collect, how we use it, and your rights under data protection
                  laws, including the{" "}
                  <strong>General Data Protection Regulation (GDPR)</strong> and
                  the <strong>California Consumer Privacy Act (CCPA)</strong>.
                </p>
                <h3>1. Information We Collect</h3>
                <span>
                  We may collect and process the following types of data:
                </span>
                <ul>
                  <li>
                    <strong>Account Information</strong>: Email address,
                    username, encrypted password.
                  </li>
                  <li>
                    <strong>Contact Information</strong>: Name, email, and phone
                    (if provided via contact forms).
                  </li>
                  <li>
                    <strong>Usage Data</strong>: Pages visited, features used
                    (e.g. filters, Compare Odds, AI tools), session duration,
                    and clicks.
                  </li>
                  <li>
                    <strong>Technical Information</strong>: Browser type,
                    device, operating system, and IP address (for security and
                    diagnostics).
                  </li>
                  <li>
                    <strong>Cookies</strong>: Used to maintain sessions,
                    remember preferences, and analyze performance.
                  </li>
                </ul>

                <h3>2. How We Use Your Information</h3>
                <span>We use the information we collect to:</span>
                <ul>
                  <li>
                    Provide and maintain access to the SportBeagle platform
                  </li>
                  <li>
                    Improve user experience and personalize your interface
                  </li>
                  <li>Offer AI-powered betting suggestions</li>
                  <li>Analyze traffic and site performance</li>
                  <li>Respond to user inquiries and support requests</li>
                  <li>
                    Communicate updates and optional newsletters (only if
                    subscribed)
                  </li>
                </ul>
                <p>
                  We do <strong>not sell</strong>, trade, or rent your personal
                  information to third parties. We do{" "}
                  <strong>not share data</strong> with bookmakers or
                  advertisers.
                </p>

                <h3>3. Cookies & Tracking Technologies</h3>
                <p>Cookies help us:</p>
                <ul>
                  <li>Keep you logged in</li>
                  <li>Remember your selected filters and preferences</li>
                  <li>Track platform usage via anonymized analytics</li>
                </ul>
                <p>
                  You can disable cookies in your browser settings at any time.
                </p>

                <h3>4. Data Security</h3>
                <p>We take your data seriously. Measures we use include:</p>
                <ul>
                  <li>SSL encryption for data transfer</li>
                  <li>Encrypted password storage</li>
                  <li>Limited access to data by authorized staff only</li>
                  <li>Secure cloud infrastructure</li>
                </ul>

                <h3>5. Your Rights Under GDPR (EU Users)</h3>
                <p>
                  If you are located in the European Union, under GDPR, you have
                  the right to:
                </p>
                <ul>
                  <li>Access the data we hold about you</li>
                  <li>Request correction of inaccurate data</li>
                  <li>
                    Request deletion of your personal data ("Right to be
                    Forgotten")
                  </li>
                  <li>Restrict or object to certain data processing</li>
                  <li>Receive a copy of your data (data portability)</li>
                </ul>
                <p>
                  To exercise any of these rights, please contact us via the{" "}
                  <strong>Contact Us</strong> page.
                </p>

                <h3>6. Your Rights Under CCPA (California Residents)</h3>
                <p>If you are a California resident, you have the right to:</p>
                <ul>
                  <li>
                    Know what personal information we collect, use, and share
                  </li>
                  <li>Request deletion of your personal data</li>
                  <li>
                    Opt out of the sale of personal information (note:{" "}
                    <strong>we do not sell data</strong>)
                  </li>
                  <li>
                    Not face discrimination for exercising any of your CCPA
                    rights
                  </li>
                </ul>
                <p>
                  To make a CCPA request, contact us via the{" "}
                  <strong>Contact Us</strong> page.
                </p>

                <h3>7. Data Retention</h3>
                <p>
                  We retain user data only as long as necessary for the purposes
                  stated in this policy, or as required by law. You can request
                  account deletion at any time.
                </p>

                <h3>8. Changes to This Policy</h3>
                <p>
                  This Privacy Policy may be updated as needed. We will notify
                  users of major changes and update the "Last updated" date at
                  the top of this page.
                </p>

                <h3>9. Contact Us</h3>
                <p>
                  For any privacy-related questions, requests, or feedback,
                  please reach out through our <strong>Contact Us</strong> form
                  on the website.
                </p>
              </div>
            </div>
          </section>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
